import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const dialogComponent = {
  backdrop: 'dialog.backdrop',
} as const satisfies ComponentLocatorMap;
